var map = {
	"./SusPredict/01-cover.png": 693,
	"./SusPredict/Captura de Tela 2026-07-20 às 10.30.17.png": 999,
	"./SusPredict/Captura de Tela 2026-07-20 às 10.30.23.png": 614,
	"./SusPredict/Captura de Tela 2026-07-20 às 10.30.30.png": 890,
	"./SusPredict/Captura de Tela 2026-07-20 às 10.30.37.png": 557,
	"./SusPredict/Captura de Tela 2026-07-20 às 10.30.51.png": 365,
	"./SusPredict/Captura de Tela 2026-07-20 às 10.31.03.png": 871,
	"./SusPredict/Captura de Tela 2026-07-20 às 10.31.09.png": 637,
	"./blacktrunk-v2/1-cover.png": 683,
	"./blacktrunk-v2/Captura de Tela 2026-07-20 às 10.23.11.png": 149,
	"./blacktrunk-v2/Captura de Tela 2026-07-20 às 10.23.31.png": 111,
	"./blacktrunk-v2/Captura de Tela 2026-07-20 às 10.23.40.png": 987,
	"./blacktrunk-v2/Captura de Tela 2026-07-20 às 10.23.57.png": 575,
	"./blacktrunk-v2/Captura de Tela 2026-07-20 às 10.24.28.png": 292,
	"./furiabot/1-cover.png": 273,
	"./innovateit/1-cover.jpg": 36,
	"./mentalaid/1-cover.png": 490,
	"./mentalbalance/1-cover.png": 920,
	"./monitor-lojas/1-cover.png": 155,
	"./nexus/1-cover.jpg": 500,
	"./oceansense/1-cover.png": 329,
	"./spotlite/1-cover.png": 313
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 925;